// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const Metrics: React.FunctionComponent<any> = (props) => {
    return (
        <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M0 -6.99382e-07L11 -2.18557e-07L11 4L-1.74846e-07 4L0 -6.99382e-07ZM-2.62268e-07 6L16 6L16 10L-4.37114e-07 10L-2.62268e-07 6ZM-5.24537e-07 12L7 12L7 16L-6.99382e-07 16L-5.24537e-07 12Z"
                fill="#585858"
            />
        </SvgIcon>
    );
};
